import { cn } from "@/lib/utils";

export function Spinner({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "border-4 border-primary border-t-transparent rounded-full animate-spin",
        className,
      )}
    />
  );
}
